<template>
    <div class="tab-text">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Mobile No.</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    SMS notifications will sent to this number
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.phone"
                    onkeypress="return /^[-+0-9]/i.test(event.key)"
                    onpaste="return false"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Email</span>
                <div style="font-size:0.75rem; color:#aaa;">
                    Email notifications will be sent to this email
                </div>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    v-validate="{regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                    name="email"
                    class="w-full"
                    v-model="form.email"
                    :maxLength="254"
                />
                <span class="text-danger text-sm" v-show="errors.has('email')">
                    {{ errors.first("email") }}
                </span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Contact Person</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    class="w-full"
                    v-model="form.contactperson"
                    :maxLength="100"
                />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Shipping Address</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="form.shipaddress" />
            </div>
        </div>
        <div style="height:10px;"></div>
        <div class="vx-row pt-5 mt-5">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
            <vs-button v-if="showSellerCancel" class="mr-3 mb-2" type="border" @click="canceled">Cancel </vs-button>
          </div>
        </div>
    </div>
</template>

<script>
import Service from "@/services";

import { timezones } from "@/utils/Timezones";

export default {
    props: [ 'form', 'e' ],
    data() {
        return {
            posterUploadUrl: process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
            posterUploadHeader: {
                Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
            },
            posterData: {
                type: "poster"
            },
            timezones: timezones,
            showSellerCancel: false,
        }
    },
    methods: {
        submitBasic() {
            const path = this.$route.path.includes('/sellers/')
            if (path) {
                this.$emit('submitBasic', this.form)
            }
            else {
                this.$vs.loading();
                const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
                Service.Event.saveMerchant(formData, this.e)
                    .then(res => {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            title: "Success",
                            text: "Update complete.",
                            color: "success"
                        });
                    })
                    .catch(e => {
                        this.$vs.loading.close();
                    });
            }
        },
        canceled() {
            this.$router.push('/sellers')
        }
    },
    mounted() {
        this.showSellerCancel = this.$route.path.includes('/sellers/') ? true: false;
    }
    
};
</script>
